import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaFacebookF, 
  FaYoutube, 
  FaLinkedinIn, 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope,
  FaChevronRight
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-main-section">
      <div className="footer-top-container">

        {/* --- Column 1: Brand & Hindi Description --- */}
        <div className="footer-col footer-about">
          <h3 className="footer-brand-title">राजपूत शिक्षा कोष</h3>
          <p className="footer-hindi-desc">
            राजपूत समाज के हमारे भाइयो के आर्थिक पिछड़ेपन के कारण समाज की 70% आबादी गरीबी रेखा से नीचे जीवनयापन करने को विवश है. इन विषम परिस्थितियों में भी इन आभावग्रस्त राजपूत भाइयो के परिवारों में अनेको बच्चे बहुत ही प्रतिभावान एव होनहार निकल रहे है.
          </p>
        </div>

        {/* --- Column 2: Quick Links --- */}
        <div className="footer-col footer-links">
          <h4 className="footer-subtitle">Quick Links</h4>
          <ul className="footer-links-grid">
            <li><Link to="/"><FaChevronRight className="link-icon" /> Home</Link></li>
            <li><Link to="/about/mission-vision"><FaChevronRight className="link-icon" /> About Us</Link></li>
            <li><Link to="/history/ideal-history"><FaChevronRight className="link-icon" /> History</Link></li>
            <li><Link to="/news"><FaChevronRight className="link-icon" /> News</Link></li>
            <li><Link to="/gallery"><FaChevronRight className="link-icon" /> Gallery</Link></li>
            <li><Link to="/events"><FaChevronRight className="link-icon" /> Events</Link></li>
            <li><Link to="/about/members"><FaChevronRight className="link-icon" /> Member</Link></li>
            <li><Link to="/contact"><FaChevronRight className="link-icon" /> Contact Us</Link></li>
            <li><Link to="/privacy-policy"><FaChevronRight className="link-icon" /> Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions"><FaChevronRight className="link-icon" /> Terms & Conditions</Link></li>
            <li><Link to="/refund"><FaChevronRight className="link-icon" /> Refund & Cancellation</Link></li>
          </ul>
        </div>

        {/* --- Column 3: Follow Us --- */}
        <div className="footer-col footer-social">
          <h4 className="footer-subtitle">Follow Us</h4>
          <div className="footer-social-wrapper">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-box fb" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="social-box x-twitter" aria-label="X Twitter">
              <FaXTwitter />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" className="social-box youtube" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-box linkedin" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* --- Column 4: Contact Us --- */}
        <div className="footer-col footer-contact">
          <h4 className="footer-subtitle">Contact Us</h4>
          <div className="contact-item">
            <FaMapMarkerAlt className="contact-icon" />
            <p>Marwar Rajput Sabha Bhawan, <br /> Paota 'B' Road, Jodhpur(342001)</p>
          </div>
          <div className="contact-item">
            <FaPhoneAlt className="contact-icon" />
            <p>9414133996, 9829266066</p>
          </div>
          <div className="contact-item">
            <FaEnvelope className="contact-icon" />
            <p>rajputshikhshakosh@gmail.com</p>
          </div>
        </div>

      </div>

      {/* --- Bottom Bar: Saffron Background --- */}
      <div className="footer-bottom-bar">
        <div className="footer-bottom-container">
          <p>
            Copyright 2015-{currentYear} Rajput Shkisha Kosh. All Rights Reserved | 
            Designed by <a href="https://dheersoftwaresolutions.com" target="_blank" rel="noreferrer">Dheer Software Solutions</a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;